var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 90,
    viewBox: "0 0 86 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.6207 0.19165V89.8728H0L12.4269 45.0322L0 0.19165H85.6207Z",
    fill: "url(#paint0_linear_126_166)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 42.75C48.7205 42.75 52.75 38.7206 52.75 33.75C52.75 28.7794 48.7205 24.75 43.75 24.75C38.7794 24.75 34.75 28.7794 34.75 33.75C34.75 38.7206 38.7794 42.75 43.75 42.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3054 60.7955C28.2877 53.0089 35.3463 47.25 43.75 47.25C52.1538 47.25 59.2122 53.0089 61.1945 60.7955C61.8078 63.2041 59.7354 65.25 57.25 65.25H30.25C27.7647 65.25 25.6923 63.2041 26.3054 60.7955Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 36C60.7427 36 61.75 37.0074 61.75 38.25V40.5H64C65.2427 40.5 66.25 41.5073 66.25 42.75C66.25 43.9927 65.2427 45 64 45H61.75V47.25C61.75 48.4927 60.7427 49.5 59.5 49.5C58.2573 49.5 57.25 48.4927 57.25 47.25V45H55C53.7573 45 52.75 43.9927 52.75 42.75C52.75 41.5073 53.7573 40.5 55 40.5H57.25V38.25C57.25 37.0074 58.2573 36 59.5 36Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_126_166",
    x1: 68.241,
    y1: 0.19165,
    x2: 68.241,
    y2: 89.8727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C32A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A5298"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.d9c786348130b438eefa9be856d2b288.svg";
export { ForwardRef as ReactComponent };